import * as React from "react";
import { useParams, Switch, Route, useRouteMatch } from "react-router-dom";

// Pages & Components
import QuestionPage from "./Question.page";
import TopicIntro from "../components/TopicIntro/TopicIntro";
import QuestionOverview from "../components/QuestionOverview/QuestionOverview";
import FloatingNavigation from "../components/FloatinNavigation/FloatingNavigation";
import Footer from "../components/Footer/Footer";

// Misc.
import Topic from "../types/Topic.interface";
import Question from "../types/Question.interface";
import { extractMustHaves, extractShouldHaves } from "../lib/Question.lib";
import { ConditionProvider } from "../context/Condition.context";

const TopicPage: React.FC = () => {
  const { categoryId } = useParams();
  const { url, path } = useRouteMatch();
  const [topic, setTopic] = React.useState<Topic | null>(null);
  const [mustHaves, setMustHaves] = React.useState<Question[] | null>(null);
  const [shouldHaves, setShouldHaves] = React.useState<Question[] | null>(null);

  React.useEffect(() => {
    if (categoryId) {
      fetch(`/api/v1/topic/${categoryId}`)
        .then((response) => response.json())
        .then((topicData) => {
          const extractedMustHaves = extractMustHaves(topicData.questions);
          const extractedShouldHaves = extractShouldHaves(topicData.questions);
          setMustHaves(extractedMustHaves);
          setShouldHaves(extractedShouldHaves);
          setTopic(topicData);
        });
    }
  }, [categoryId]);

  if (topic) {
    return (
      <Switch>
        <Route exact path={path}>
          <TopicIntro
            title={topic.title}
            description={topic.description}
            imageUrl={topic.imageUrl}
          />
          {mustHaves && mustHaves.length > 0 && (
            <QuestionOverview
              questions={mustHaves}
              parentUrl={url}
              className="bg-dw-grey-01 mt-4"
              title="Must-Haves"
            />
          )}
          {shouldHaves && shouldHaves.length > 0 && (
            <QuestionOverview
              questions={shouldHaves}
              parentUrl={url}
              title="Should-Haves"
            />
          )}
          <FloatingNavigation />
          <Footer />
        </Route>
        <Route path={`${path}/q/:questionId`}>
          <ConditionProvider>
            <QuestionPage />
          </ConditionProvider>
        </Route>
      </Switch>
    );
  }

  return <p>Loading</p>;
};

export default TopicPage;
